import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconLeft: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props}>
      <circle cx="12" cy="12" r="12" fill="#F7F7F8" />
      <path d="M14 7.3335L9.33333 12.0002L14 16.6668" stroke="#262F56" />
    </Icon>
  );
};

export default IconLeft;
